<script>
    export let options;

    let months = [
        { 'number': '1', 'name': 'January' },
        { 'number': '2', 'name': 'February' },
        { 'number': '3', 'name': 'March' },
        { 'number': '4', 'name': 'April' },
        { 'number': '5', 'name': 'May' },
        { 'number': '6', 'name': 'June' },
        { 'number': '7', 'name': 'July' },
        { 'number': '8', 'name': 'August' },
        { 'number': '9', 'name': 'September' },
        { 'number': '10', 'name': 'October' },
        { 'number': '11', 'name': 'November' },
        { 'number': '12', 'name': 'December'}
    ];
</script>

<div class="col-md-2 mt-3">
    <div class="dropdown" id="month-selector" >
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownMonth" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            { months[options.month-1].name}
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownMonth">
            {#each months as month}
                <a
                on:click={ () => options.month = month.number }
                class="dropdown-item"
                href="/{options.menu.url}/{options.org.id}{(options.subMenu)?'/'+options.subMenu:''}/{options.year}/{month.number}">
                    {month.name}
                </a>
            {/each}
        </div>
    </div>
</div>
